/**
 *   路由引入
 */
import Client   from  '@/components/client/client'
import Filter   from  '@/components/client/filter'
import ClientDetails  from  '@/components/client/clientDetails'
import StayClient     from  '@/components/client/stayClient'
import StoresNumbers  from  '@/components/client/storesNumbers'
import client360  from  '@/components/client/client360'
import customerTraffic from '@/components/client/customerTraffic'
import editCustomerTraffic from '@/components/client/childCompoents/editCustomerTraffic'
import viewCustomerTraffic from '@/components/client/childCompoents/viewCustomerTraffic'
import submitSurvey from '@/components/client/childCompoents/submitSurvey'
import viewSurvey from '@/components/client/childCompoents/viewSurvey'
export default  [
    {
        path: '/Client',
        name: 'Client',
        component: Client,
        meta:{
          title:"客户信息列表"
        }
      },{
        path: '/Filter',
        name: 'Filter',
        component: Filter,
        meta:{
          title:"高级搜索"
        }
      },
      {
        path: '/ClientDetails',
        name: 'ClientDetails',
        component: ClientDetails,
        meta:{
          title:"客户详情"
        }
      },{
        path: '/StayClient',
        name: 'StayClient',
        component: StayClient,
        meta:{
          title:"待分派客户列表"
        }
      },{
        path: '/StoresNumbers',
        name: 'StoresNumbers',
        component: StoresNumbers,
        meta:{
          title:"到店人数"
        }
      },{
        path: '/client360',
        name: 'client360',
        component: client360,
        beforeEnter: (to, from, next) => {
          if (from.path === '/' && to.path !='/client360') {
            // 如果是从特定路径来，直接替换历史记录
            next({ path: '/client360', replace: true });
          } else {
            // 正常进入360页面
            next();
          }
        },
        meta:{
          title:"客户360"
        }
      },
      {
        path: '/customer-traffic',
        name: 'customerTraffic',
        component: customerTraffic,
        meta:{
          title:"到店客流列表"
        }
      },
      {
        path: '/edit-customer-traffic',
        name: 'editCustomerTraffic',
        component: editCustomerTraffic,
        meta:{
          title:"到店客流"
        }
      },
      {
        path: '/view-customer-traffic',
        name: 'viewCustomerTraffic',
        component: viewCustomerTraffic,
        meta:{
          title:"到店客流"
        }
      },
      {
        path: '/submit-survey',
        name: 'submitSurvey',
        component: submitSurvey,
        meta:{
          title:"问卷调查"
        }
      },
      {
        path: '/view-survey',
        name: 'viewSurvey',
        component: viewSurvey,
        meta:{
          title:"查看问卷"
        }
      },
]



// WEBPACK FOOTER //
// ./src/router/clients.js